import SaveCaseProgressButton from "./SaveCaseProgressButton";
import {ReactComponent as MedicalSummaryButtonIcon } from '../../assets/icons/Vector.svg'

const CaseFormFooter = ({ backToCases, handlePrevious, innerRef, formSteps, values}) => {
    return (
        <footer className='bg-light py-3 mt-4 border-top fixed-footer'>
            <div className='container'>
                <div className='d-flex justify-content-between align-items-center btm-btns' ref={innerRef}>
                    <div className="btns text-center button-spacing">
                    <a onClick={backToCases} className="text-theme fw-semibold"><i className='fa fa-arrow-left me-2'></i>Back to Case List</a>
                    <SaveCaseProgressButton innerRefs={innerRef} isFromCase={true} />
                    </div>
                    <div className="btns text-center button-spacing">
                        <button type='button' id="previous" style={{marginLeft:'20px'}}className={`btn button-as-link fw-semibold ${formSteps ===0 ? 'disabled' : ''}`} onClick={() => handlePrevious?.(values)}><i className='fa fa-arrow-left'></i><span className="ms-2">Previous</span></button>
                        <button type="submit" id="submit"
                            className={formSteps === 4 ? "generate-demand-btn" : "btn button-as-link fw-semibold"}>
                            <span className="me-2">{formSteps === 4 ? <span className="me-2" style={{color: 'white'}}>
                                <MedicalSummaryButtonIcon />
                            </span> : ""}{formSteps === 4 ? 'Generate Demand' : 'Next'}</span>
                            {formSteps === 4 ? "" : <i className='fa fa-arrow-right'></i>}
                        </button>
                   
                   
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default CaseFormFooter

